module.exports = "/_next/static/images/Le_Cordon_Blue-b2ee8897f0feba13bb4abd8ebf9149a5.png";